<elcia-title [title]="'entity.products' | translate" [iconType]="'tag'"/>
<elcia-tabs [items]="items"/>
<router-outlet></router-outlet>
